import { render } from "./NewTargetModal.vue?vue&type=template&id=1c419ae7&ts=true"
import script from "./NewTargetModal.vue?vue&type=script&lang=ts"
export * from "./NewTargetModal.vue?vue&type=script&lang=ts"

import "./NewTargetModal.vue?vue&type=style&index=0&id=1c419ae7&lang=scss"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__